import React from "react";
import { AbsoluteFill, Freeze, useCurrentFrame } from "remotion";
import { SfxPack, SfxWarp } from "../kit/brand";
import { makeWarp } from "../kit/warp";
import { BookingCues, BookingIntro, BookingMusic, LAND_AT, type BookingIntroProps } from "./BookingIntro";
import { BOOKING_MEDIA } from "./media";
import { BOOKING_FRAMES } from "./scene";

// Luuk, 29 Sep: the hook's stays went by too fast. Its five cuts of 15 frames land on Bangkok at
// frame 76; slowed, they are cuts of 24 and land at 122. Rather than retime every cue by hand, the
// film's clock is remapped (../kit/warp.ts): the hook is stretched, and everything after it is the
// same film, 46 frames later.
export const BOOKING_WARP = makeWarp(LAND_AT, 122);

// 1066 frames, 35.53 s at 30 fps
export const BOOKING_SLOW_FRAMES = BOOKING_FRAMES + BOOKING_WARP.extra;

/**
 * The booking intro as it ships: the film rendered inside a <Freeze> at the remapped frame (it takes
 * a fractional frame, and the clips, the map stage and every spring follow it). Sound cannot be
 * frozen, so the film plays none of its own: the effects are its cue list outside the Freeze, each
 * cue moved by the same map, and the music runs on the output's own clock.
 */
export const BookingIntroSlow: React.FC<BookingIntroProps> = (props) => {
	const { musicVolume = 0.66, sfxPack = "sfx-hotel", noSfx = false, media } = props;
	const f = useCurrentFrame();
	const music = media?.music ?? BOOKING_MEDIA.music;
	return (
		<AbsoluteFill>
			<Freeze frame={BOOKING_WARP.w(f)}>
				<BookingIntro {...props} musicVolume={0} noSfx />
			</Freeze>
			{musicVolume > 0 && <BookingMusic src={music} volume={musicVolume} />}
			{!noSfx && (
				<SfxWarp.Provider value={BOOKING_WARP.inv}>
					<SfxPack.Provider value={sfxPack}>
						<BookingCues />
					</SfxPack.Provider>
				</SfxWarp.Provider>
			)}
		</AbsoluteFill>
	);
};
